<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <v-container>
        <v-toolbar dense class="mb-2 indigo white--text" flat>
            <v-toolbar-title>Contact Info</v-toolbar-title>
        </v-toolbar>
        <v-row dense>
            <v-col md="12">
                <v-text-field
                        v-model="orgData.contactInfo.name"
                        label="Admin Name"
                        :clearable="!readonly"
                        single-line
                        :readonly="readonly">
                </v-text-field>
            </v-col>
            <v-col md="12">
                <v-text-field
                        v-model="orgData.contactInfo.dprtmnt"
                        label="Department/Title"
                        :clearable="!readonly"
                        single-line
                        :readonly="readonly">
                </v-text-field>
            </v-col>
            <v-col md="12">
                <v-text-field
                        v-model="orgData.contactInfo.phone"
                        label="Phone Number"
                        :clearable="!readonly"
                        single-line
                        :readonly="readonly">
                </v-text-field>
            </v-col>
            <v-col md="12">
                <v-text-field
                        v-model="orgData.contactInfo.email"
                        label="Email Address"
                        :clearable="!readonly"
                        single-line
                        :readonly="readonly">
                </v-text-field>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default
    {
        name: 'org-contact-info',
        data: function ()
        {
            return {
            }
        },
        props:
        {
            readonly: true,
            orgData: {}
        }
    }
</script>

<style scoped>

</style>